import React, { useState, useEffect, useRef } from 'react';
import {
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  Input,
  Box,
} from '@chakra-ui/react';
import TableWrapper from 'components/tableWrapper/tableWrapper';
import PermissionGroupApi from 'api/permissiongroup';
import { useSelectedPermissions } from 'contexts/PermissionGroupArrayContext';

const AllPermissionsTable = ({ AddToArray }, ...props) => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [listTotal, setListTotal] = useState(2);
  const [searchTerm, setSearchTerm] = useState('');
  const [isError, setIsError] = useState('');

  const debounceTimeout = useRef(null); // Reference to track debounce timeout
  const handleInputChange = (value) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      handleSearch(value); // Call the actual search handler after debounce time
    }, 800); // Debounce delay (e.g., 800ms)
  };
  const handleSearch = async (search) => {
    setSearchTerm(search);
  };

  const {
    addToSelectedPermissions,
    removeFromSelectedPermissions,
    resetSelectedPermissions,
  } = useSelectedPermissions();
  const [clickedRows, setClickedRows] = useState({});

  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

  const fetchAllPermissions = async () => {
    try {
      setLoading(true);
      let response = await PermissionGroupApi.ListAll({
        currentPage,
        itemsPerPage,
        sort: 'name:asc',
        searchTerm,
      });
      response = response.data;
      setLoading(false);
      if (response.status_code === 200 && response?.data?.list?.length > 0) {
        setList(response?.data?.list);
        setListTotal(response?.data?.total);
      } else {
        setList(null);
        setListTotal(0);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    fetchAllPermissions();
  }, [currentPage, searchTerm]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const handleRowClick = (permission) => {
    addToSelectedPermissions(permission);
    setClickedRows((prevClicked) => ({
      ...prevClicked,
      [permission.id]: true,
    }));
  };

  const handleRowClickRemove = (permission) => {
    removeFromSelectedPermissions(permission.id);
    setClickedRows((prevClicked) => {
      const updatedClickedRows = { ...prevClicked };
      delete updatedClickedRows[permission.id];
      return updatedClickedRows;
    });
  };

  return (
    <Flex
      height='100%'
      direction='column'>
      <Flex
        py={5}
        gap={6}>
        <Box>
          <Input
            variant='auth'
            type='text'
            placeholder='Search ..'
            onChange={(e) => handleInputChange(e.target.value)} // Use debounced handler
          />
        </Box>
        <Button
          bgColor='grey.100'
          _hover={{ cursor: 'pointer', bgColor: 'gray.300' }}
          onClick={() => {
            resetSelectedPermissions();
            setClickedRows({});
          }}>
          Reset Selection
        </Button>
      </Flex>

      <TableWrapper
        list={list}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        listTotal={listTotal}
        itemsPerPage={itemsPerPage}
        isError={isError}>
        <Table
          variant='striped'
          color='gray.500'
          mb='24px'>
          <Thead>
            <Tr>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Sr.no
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Name
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Module Name
                </Flex>
              </Th>
            </Tr>
          </Thead>

          <Tbody>
            {list?.map((obj, index) => {
              return (
                <Tr
                  _hover={{ cursor: 'pointer', bgColor: 'gray.200' }}
                  onClick={
                    !clickedRows[obj.id]
                      ? () => handleRowClick(obj)
                      : () => handleRowClickRemove(obj)
                  }
                  style={{
                    cursor: clickedRows[obj.id] ? 'default' : 'pointer',
                    backgroundColor: clickedRows[obj.id]
                      ? '#cef2d2'
                      : 'transparent',
                  }}
                  key={obj.id}>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {(currentPage - 1) * 10 + (index + 1)}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.name}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.module_name}
                      </Text>
                    </Flex>
                  </Td>
                </Tr>
                // </Link>
              );
            })}
          </Tbody>
        </Table>
      </TableWrapper>
    </Flex>
  );
};

export default AllPermissionsTable;
